export const CARD_TYPES = [{
    value: '1',
    viewValue: 'Unanswered questions'
},
];